import React, {useContext, useEffect} from 'react';
import {Navigate, useLocation} from 'react-router-dom';
import {AppContext} from "../context/appContext";
import {types} from "../shared/types/types";
import {permisos} from "../api/auth.service";
import {useNavigate} from "react-router";

export const PrivateRoute = ({children}) => {
    const {dispatch} = useContext(AppContext);
    const {user} = useContext(AppContext);
    const {pathname, search} = useLocation();
    const navigate = useNavigate();
    let route = pathname + search;

    useEffect(() => {
        const action = {
            type: types.showMenu,
            payload: false
        }
        dispatch(action)
        async function guardarPermisos() {

            if (route === "/home" || route=== "/profile") {
                let name = (route === "/home")? "Inicio": "Perfil";

                return {
                    submenu: name,
                    consultar: 1,
                    editar: 1,
                    eliminar: 1,
                    adicionar: 1
                }
            } else {
                const data = {
                    route
                }
                const response = await permisos(data);
                const dataRes = response.data;
                if (dataRes.estado !== 200) {
                    navigate("/home")
                    return false;
                }
                return dataRes.data;
            }


        }

        guardarPermisos().then(r => {
            if (!r) {
                return
            }
            if (r.consultar === 0 ) {
                navigate("/home")
            }
            const payload = {
                submenu: r.submenu,
                consultar: r.consultar,
                editar:r.editar,
                eliminar: r.eliminar,
                adicionar: r.adicionar
            }

         const action = {
             type: types.updatePermis,
             payload
         }
         dispatch(action);

        });
    }, [route, dispatch, navigate]);

    localStorage.setItem('lastPath', pathname + search);

    return user.logged
        ? children
        : <Navigate to="/login"/>
}
